import { render, staticRenderFns } from "./discount-block.vue?vue&type=template&id=1f2638c4"
import script from "./discount-block.vue?vue&type=script&lang=js"
export * from "./discount-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports